import { ITimeHubClientMethods } from "./Models/ITimeHubClientMethods";
import { InstanceManager } from "./InstanceManager";

export class TimeHubClientMethods implements ITimeHubClientMethods {
	async TriggerSync(): Promise<void> {
		console.debug("Sync triggered by server");
		await InstanceManager.syncManager.SyncImmediately();
	}
}
